/**
 * FAQ items rendered both as the on-page accordion (FAQ.tsx) and as
 * FAQPage JSON-LD on the landing page so Google can show them as
 * rich snippets.
 *
 * Keep `q` and `a` as plain strings — the JSON-LD schema requires
 * plain text.
 */

export type FAQ = {
  id: string;
  q: string;
  a: string;
};

export const FAQS: FAQ[] = [
  {
    id: "what-is-shit-test",
    q: "What's a shit test?",
    a: "A shit test is a quick, sometimes playful, sometimes pointed challenge a girl drops to see how you react under pressure. \"You're not really my type\". \"How old are you?\" \"You give off serial dater vibes.\" Most guys freeze, get defensive, or try too hard. ManUp drills the reflex to flip them.",
  },
  {
    id: "how-different",
    q: "How is this different from reading dating advice on Reddit?",
    a: "Reading vs. reps. You can read every Mystery and Corey Wayne post on the internet, but the response still won't come out of your mouth at the moment that matters. ManUp gives you live reps with AI personas so it becomes muscle memory.",
  },
  {
    id: "free",
    q: "Is it free?",
    a: "Yes. You can train shit tests with no signup. Sign up to track your skill levels and unlock AI scenarios. There's a paid tier for unlimited play, but you can go a long way for free.",
  },
  {
    id: "real",
    q: "Are the personas real people?",
    a: "No. Every persona is an AI built from a brief (\"club bartender, 23, tired of drunk guys\", etc.). They're trained to behave like a real person would in that context — which means they will reject you, test you, and walk away if you misplay it.",
  },
  {
    id: "skills",
    q: "What skills does ManUp train?",
    a: "Frame, Humor, Flirt, and Signals. You'll see your level on each one go up the more you train. The leaderboard ranks you by overall XP.",
  },
  {
    id: "anonymous",
    q: "Will my responses show up anywhere public?",
    a: "By default, your training responses can show up in the community feed (anonymously) so others can learn from how you handled a test. You can disable this in your profile.",
  },
];
